var GraphQlApiResult = /** @class */ (function () {
    function GraphQlApiResult(apiResult) {
        this.status = apiResult.status;
        this.total = apiResult.total;
    }
    Object.defineProperty(GraphQlApiResult.prototype, "ok", {
        /**
         * the response was successful (status in the range 200-299) or not.
         * https://developer.mozilla.org/en-US/docs/Web/API/Response/ok
         */
        get: function () {
            return this.status >= 200 && this.status <= 299;
        },
        enumerable: false,
        configurable: true
    });
    GraphQlApiResult.prototype.setTotalFromString = function (total) {
        if (!total) {
            return;
        }
        this.total = parseInt(total);
    };
    return GraphQlApiResult;
}());
export default GraphQlApiResult;
//# sourceMappingURL=GraphQlApiResult.js.map